import { IUser, TENANT_PAYWAY_CHECK_METHODS, Tenant } from '___types'

export const getTenant = (): Tenant => window.location.host.split(/[.:/]+?/g)[0] as Tenant

export const tenantPaywallCheck = (user: IUser) => {
  const tenant = getTenant()
  const paywallCheckMethod = TENANT_PAYWAY_CHECK_METHODS[tenant]
  return typeof paywallCheckMethod === 'function' ? paywallCheckMethod(user) : false
}
